const acfformactivitiesSetup = () => {
  const components = document.querySelectorAll('[data-component-acfform-activities]');

  components.forEach((component) => {

  });


  // for intermediate save of activiteiten form, this function will disable javascript validation when form is not definite accepted as done, 
  $('#activiteit-form').on('submit', function (event) {
       
    if (!$("#acf-field_597f12122aa34-1:checked").length) {
     acf.validation.active = 0;
      console.log(acf.validation.active);
    }
  });

};
acfformactivitiesSetup();



jQuery(window).bind("load", function () {


    var label = $("body.page-template-page-mijn-activiteit label[for='acf-_post_title']");
    label.html("Titel activiteit <span class=\"acf-required\">*</span>");

  //prefill the Activiteiten form with location details, should be done when page is loaded
  if($('#loc_def_values').length) {
    if(!$('#acf-field_5cb1a1b974f13').val()) {
      // the adres field is empty, lets fill in in.
      //adres
      $('#acf-field_5cb1a1b974f13').val($('#loc_def_values').attr('data-item-loc_naam'));
      $('#acf-field_59550630f9ffc').val($('#loc_def_values').attr('data-item-loc_adres'));
      $('#acf-field_65fc51846cc43').val($('#loc_def_values').attr('data-item-loc_huisnummer'));
      $('#acf-field_5955064df9ffd').val($('#loc_def_values').attr('data-item-loc_plaats'));
      $('#acf-field_5b0bef194753c').val($('#loc_def_values').attr('data-item-loc_postcode'));
      $('#acf-field_5955064df9ffd').val($('#loc_def_values').attr('data-item-loc_plaats'));
      
      // prefill the google maps search widget using address and city, we use a Timeout script so the Google map search is triggered when everything is loaded
      setTimeout(function(){

      $('input.search').val($('#loc_def_values').attr('data-item-loc_adres')+', ' + $('#loc_def_values').attr('data-item-loc_plaats'));
      $('a[data-name="search"]').trigger("click");

      }, 4000);
     
    }
  }

});